import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css'; // Optional external CSS

const CustomTour = () => {
const navigate = useNavigate();

const handleClick = () => {
    navigate('/contact-us'); // e.g., '/contact' or '/booking'
  };


  return (
    <div className="custom-tour-container">
      <div className="left-column">
      <h3>Make It Unforgettable </h3>
        <h2>Ready for a One-of-a-Kind</h2>
        <h3>Travel Experience?</h3>
        <button className="tour-button2" onClick={handleClick}>Make Your Travel Plan with Us</button>
      </div>
      <div className="right-column">
        <img
          src="./images/map2.png"

          className="tour-image"
        />
      </div>
    </div>
  );
};

export default CustomTour;
